const localStorageKeys = {
    NO_RESOURCE_CREATED_KEY: 'noResourceCreated',
    SHOW_STATISTICS_TIPS: 'showStatisticsTips',
    CREATED_RESOURCES: 'createdResources',
    SHOW_TUTORIALS_AFTER_PAYMENT: 'showTutorialsAfterPayment',
    IS_AUTOREFRESH_ENABLED: 'isAutorefreshEnabled',
    TEAM_ID: 'teamId',
    TEAM: 'team',
    SORT_OPTIONS: 'sortOptions',
    IS_HEARTBEAT_AUTHOREFRESH_ENABLED: 'isHeartbeatAutoRefreshEnabled',
    IS_SERVER_AUTHOREFRESH_ENABLED: 'isServerAutoRefreshEnabled',
    tests: 'tests',
    TRIAL: 'trial',
    APPSUMO_INVOICE_UUID: 'appsumoInvoiceUuid',
    PLAN: 'plan',
    SELECTED_RESOURCE_VIEW: 'selectedResourceView',
    SSL_TLD: 'ssl_tld',
    SELECTED_CURRENCY: 'selectedCurrency',
    IS_SIDEBAR_ACTIVE: 'isSidebarActive',
    LAST_ACTIVE_DAY: 'lastActiveDay',
    IS_DARK_MODE: 'isDarkMode',
    ENABLED_METRICS: 'enabledMetrics',
    LANGUAGE: 'language'
}

export default localStorageKeys
